import React, { useEffect, useState } from "react";
import {
  getFormattedDate,
} from "../../helpers";
import DataTable from "pages/components/DataTabel1";
import { useDispatch } from "react-redux";
import { setCurrentPage } from "../../redux/generalSlice";
import { useTranslation } from "react-i18next";
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { useGetNotificationsQuery, useMarkNotificationAsReadMutation } from "redux/service/notifications";

const NotificationManagement = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const notificationsRes = useGetNotificationsQuery();
  const [markNotificationAsRead] = useMarkNotificationAsReadMutation();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    dispatch(setCurrentPage("notification-management"));
  }, []);

  return (
    <>
      <div className="container my-1">
        <div className="header card-woah border border-secondary d-flex px-4 py-2 shadow-sm w-100 my-2">

          <div className="card-title-1 lh-1">
            {t("-t", "Notifications")}
          </div>
        </div>
        <div className="card card-woah border border-secondary shadow rounded-0">
          <div className="card-body p-4">
            <DataTable
              getRowId={(row) => row.id}
              isLoading={isLoading}
              rows={notificationsRes.data}
              className="text-white bg-primary rounded-0"
              columns={[
                {
                  field: "content",
                  headerName: t("-1", "Notification"),
                  headerClassName: "text-white bg-primary rounded-0",
                  minWidth: 300,
                  flex: 1,
                  renderCell: (params) => (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => markNotificationAsRead(params.row.id)}
                      dangerouslySetInnerHTML={{ __html: params.value }}
                    />
                  ),
                },
                {
                  field: "createdAt",
                  headerName: t("-1", "Date"),
                  headerClassName: "text-white bg-primary rounded-0",
                  minWidth: 100,
                  valueGetter: ({ value }) => value,
                  valueFormatter: ({ value }) => getFormattedDate(value),
                  flex: 1,
                },
                {
                  field: "is_read",
                  headerName: "Read",
                  headerClassName: "text-white bg-primary rounded-0",
                  minWidth: 100,
                  renderCell: (params) =>
                    params.value === 1 ? (
                      <MarkEmailReadIcon color="success" />
                    ) : (
                      <MarkEmailUnreadIcon color="warning" />
                    ),
                  flex: 1,
                },
                {
                  field: "createdByName",
                  headerName: "Notified By",
                  headerClassName: "text-white bg-primary rounded-0",
                  flex: 1,
                }
              ]}
            />
          </div>
        </div>
      </div>
    </>
  );
};

NotificationManagement.defaultProps = {
  showOnHomePage: false,
};

export default NotificationManagement;
